import { Container, Grid } from "@mui/material";
import GetInTouch from "./GetInTouch";
import ContactForm from "./ContactForm";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import { StyledContent, StyledGridContainer } from "@Styled/Pages/Prefooter";

const ContactUs = () => {
  return (
    <>
      <Container sx={{ marginBottom: "5rem" }}>
        <StyledGridContainer container>
          <StyledHeadingWithGradientunderline
            variant="subtitle1"
            sx={{
              fontSize: { sm: "1.5rem", xs: "1.2rem" },
              letterSpacing: "-1px",
            }}
          >
            Contact-Us{" "}
          </StyledHeadingWithGradientunderline>
          <StyledContent
            style={{
              fontSize: "1.5rem",
              padding: "1rem 1rem",
            }}
          >
            If there is any concern, issue or defect with any of our product,
            please email us at{" "}
            <a href="mailto: info@econut.store" style={{ color: "#00844a" }}>
              info@econut.store
            </a>{" "}
            or get in touch via call or whatsapp on{" "}
            <a href="tel:+91-85913 67993" style={{ color: "#00844a" }}>
              +91-85913 67993
            </a>{" "}
            . Please note there needs to be visual photographs incontext with
            issues, defects which can be investigated by us further, or else no
            query will be responded.
          </StyledContent>
          <Grid
            item
            sm={12}
            sx={{
              marginTop: { sm: "4rem", xs: "2rem" },
              display: { sm: "flex", xs: "" },
            }}
          >
            <Grid
              item
              xs={12}
              sm={5}
              sx={{ padding: { sm: "1rem 2rem", xs: "" } }}
            >
              {/* <GetInTouch /> */}
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.7108242961795!2d72.93635907650894!3d19.164131382058706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b85e4c4fe99f%3A0x56b0cc63451f53c1!2sEconut!5e0!3m2!1sen!2sin!4v1762684262340!5m2!1sen!2sin" width="100%" height="300" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ padding: { sm: "1rem 2rem", xs: "1rem 0 0 0" } }}
            >
              <ContactForm />
            </Grid>
          </Grid>
        </StyledGridContainer>
      </Container>
    </>
  );
};
export default ContactUs;
